import { ServiceNodeDetail } from '@bumble/app/__generated__/data-contracts';
import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import { Indicator } from '@bumble/app/components/Indicator';
import NoData from '@bumble/app/components/NoData';
import { GridColDef } from '@mui/x-data-grid';
import { DateTime } from 'luxon';

const columns: GridColDef[] = [
  {
    field: 'app_service_name',
    headerName: 'Service Name',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  {
    field: 'app_service_id',
    headerName: 'Service ID',
    flex: 1,
    minWidth: 200,
    disableColumnMenu: true,
  },
  {
    field: 'deployment',
    headerName: 'Deployment',
    width: 150,
    disableColumnMenu: true,
  },
  {
    field: 'admin_state',
    headerName: 'Admin State',
    width: 150,
    disableColumnMenu: true,
  },
  {
    field: 'admin_state_change_at',
    headerName: 'Last change',
    width: 150,
    disableColumnMenu: true,
    valueGetter: (value) => {
      if (value === null) return '';
      return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    },
  },
  {
    field: 'op_state',
    headerName: 'Op State',
    width: 150,
    disableColumnMenu: true,
    renderCell: (params) => {
      return params.value !== undefined ? <Indicator active={params.value === 'up'} /> : 'N/A';
    }
  },
  {
    field: 'app_service_virtual_ip',
    headerName: 'App DNS or IP',
    width: 150,
    disableColumnMenu: true,
  },
  {
    field: 'proto',
    headerName: 'App protocol',
    width: 120,
    disableColumnMenu: true,
  },
  {
    field: 'port',
    headerName: 'App port',
    width: 100,
    headerAlign: 'right',
    align: 'right',
    disableColumnMenu: true,
  },
];

const columnVisible = {
  app_service_name: true,
  app_service_id: true,
  deployment: true,
  admin_state: true,
  admin_state_change_at: true,
  op_state: true,
  app_service_virtual_ip: true,
  proto: true,
  port: true,
};

export const ServiceNodeTabAppService = ({
  data,
  loading,
}: {
  data: ServiceNodeDetail | undefined;
  loading: boolean;
}) => {
  if (loading) return <Loading />;
  if (data === undefined) return <NoData />;

  return (
    <DataTableGrid
      rows={
        data?.app_services.map((item) => {
          return {
            ...item,
            id: item.app_service_id,
          };
        }) || []
      }
      columns={columns}
      columnVisibilityModel={columnVisible}
    />
  );
};
